import React from "react";

function BS4_StackedHorizontal() {
  return (
    <div>
      <h1>BS4_StackedHorizontal Component</h1>
      <p>This is the BS4_StackedHorizontal tutorial page content.</p>
    </div>
  );
}

export default BS4_StackedHorizontal;
